export class newVulClass{
    constructor(public Org?: string,
        public CVE?: string,
        public Description?: string,
        public Title?: string,
        public CorrectiveAction?: string,
        public VRef?: any,
        public DateRaised?: string,
        public DDL?: any,
        public Value?: string,
        public Publish?:any,
        public LastUpdatedBy? : string) {}
}